<template>
	<v-card
		color="primary"
		height="100%"
		class="fixed"
	>
		<v-layout 
			column 
			wrap 
			alig-center
			justify-center
		>
			<v-flex xs5>
				<v-data-table
					hide-actions
					hide-headers
					:items="selectedEstate.documents"
					class="table-color"
				>
					<template v-slot:items="props">
						<td class="table-color">
							Notarially Act
						</td>
						<td class="justify-center layout px-0 table-color">
							<a
								:href="props.item"
								target="_blank"
								class="custom-icon"
							>
								<v-icon
									small
									class="mr-2"
								>
									fas fa-link
								</v-icon>
							</a>
						</td>
					</template>
				</v-data-table>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
export default {
	props: ['selectedEstate'],
	data: () => ({
		
	}),
}
</script>


<style lang="scss" scoped>
@import '@/styles/index.scss';

.cont {
	height: 100% !important; 
	display:flex; 
	align-items: center;
}

.table-color {
	background-color: $secondary !important;
}

.fixed {
	overflow-x: hidden;
}

.custom-icon {
	align-items: center;
	justify-content: center;
	display: flex;
}

</style>